import { createContext, use } from "react";

import { Preferences } from "./preferences";

/**
 * `undefined` outside a `ManualPreferencesProvider`, and that absence is the signal
 * `usePreferences` branches on to fall back to the persisted preferences.
 */
export function useManualPreferences(): Preferences | undefined {
  return use(ManualPreferencesContext);
}

export const ManualPreferencesContext = createContext<Preferences | undefined>(
  undefined,
);
